module.exports = __webpack_public_path__ + "07_long_gray.1c43a306.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/07_long_gray.png
// module id = VpVt
// module chunks = 0